import type { GameState } from './types';

export interface TutorialStep {
  label: string;
  done: boolean;
}

export type GuidedTutorialStepId = 'buy-arj-finance' | 'buy-atr-used' | 'route-hkg-sha' | 'route-hkg-pvg' | 'complete';

export function isHongKongBeginnerTutorial(game: Pick<GameState, 'scenarioId' | 'singlePlayerDifficulty' | 'headquartersId' | 'tutorialCompleted'>): boolean {
  return game.scenarioId === 'sandbox'
    && game.singlePlayerDifficulty === 'beginner'
    && game.headquartersId === 'HKG'
    && !game.tutorialCompleted;
}

export function guidedTutorialStep(game: GameState): GuidedTutorialStepId {
  if (!game.aircraft.some((aircraft) => aircraft.typeId === 'ARJ21' && aircraft.acquisition === 'new' && game.loans.some((loan) => loan.aircraftId === aircraft.id))) return 'buy-arj-finance';
  if (!game.aircraft.some((aircraft) => aircraft.typeId === 'ATR72' && aircraft.acquisition === 'used' && !game.loans.some((loan) => loan.aircraftId === aircraft.id))) return 'buy-atr-used';
  if (!game.routes.some((route) => route.active && route.originId === 'HKG' && route.destinationId === 'SHA')) return 'route-hkg-sha';
  if (!game.routes.some((route) => route.active && route.originId === 'HKG' && route.destinationId === 'PVG')) return 'route-hkg-pvg';
  return 'complete';
}

export function tutorialSteps(game: GameState): TutorialStep[] {
  return [
    { label: '购买第一架飞机', done: game.aircraft.length > 0 },
    { label: '从香港开通首条航线', done: game.routes.some((item) => item.active) },
    { label: '推进一周查看现金桥', done: game.reports.length > 0 },
    { label: '处理空闲飞机或继续扩张', done: game.aircraft.length > 0 && game.aircraft.every((item) => item.routeIds.length) },
    { label: '在财务中心复盘贷款与事件', done: game.events.length > 0 || game.loans.length > 0 },
  ];
}

export function isTutorialComplete(game: GameState): boolean {
  return tutorialSteps(game).every((step) => step.done);
}

export function completeTutorialIfReady(game: GameState): GameState {
  if (game.tutorialCompleted || !isTutorialComplete(game)) return game;
  return { ...game, tutorialCompleted: true };
}
